import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['contents', 'form', 'input'];

  update(event) {
    event.preventDefault();

    if (!this.inputTargets.every(t => t.value.length)) {
      return;
    }

    this._fetchPickList()
      .then(this._updateContents.bind(this))
      .catch(error => alert(error.message));
  }

  async _fetchPickList() {
    const formData = new FormData(this.formTarget);
    const formDataQuery = new URLSearchParams(formData).toString();
    const url = `${this.formTarget.action}?${formDataQuery}`;

    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!res.ok) {
      throw new Error('An error has occurred. Please try again.');
    }

    return await res.text();
  }

  _updateContents(html) {
    const fragment = document.createRange().createContextualFragment(html);
    this.contentsTarget.replaceChildren();
    this.contentsTarget.appendChild(fragment);
  }
}
